import { render, staticRenderFns } from "./Infographic.vue?vue&type=template&id=30de3616&"
import script from "./Infographic.vue?vue&type=script&lang=js&"
export * from "./Infographic.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports